//Document ready
$(function() {
	$('.video-layer').click(function(){
    $(this).hide();
    var introVideoIframeSrc = $('.video-section iframe')[0].src.indexOf("?") > -1 ? "&" : "?";
		$('.video-section iframe')[0].src += introVideoIframeSrc + "autoplay=1";
  });
});
